import { useParams } from "react-router-dom";
import { useApp } from "../../../context/AppContext";
import { Link } from "react-router-dom";

//import resources
import { RiShoppingCartLine } from "react-icons/ri";

//import tags
import Skeleton from "react-loading-skeleton";
import { toast, Bounce } from 'react-toastify';

//import locales
import { useTranslation } from "react-i18next";
import "../../../i18n";

export default function ProductsComponent({grid, sort, data}) {

    //get locale
    const { locale } = useParams();
    const { t } = useTranslation();

    //get data
    const {toCart, setToCart} = useApp();

    const addToCart = (id) => {

        let added = false;

        setToCart((prevCart) => {
            const updatedProducts = { ...prevCart.products };
    
            if (updatedProducts[id]) {
                delete updatedProducts[id];
                
            } else {
                updatedProducts[id] = 1;
                added = true;
            }
    
            return {
                ...prevCart,
                products: updatedProducts,
            };
        });

        if (added) {
            toast.success(t('added_to_cart'), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
            });
        } else {
            toast.error(t('remove_from_cart'), {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Bounce,
            });
        }
        
    };
    

    return(
        data === null ?
            [1, 2, 3, 4, 5, 6].map((item, index) => (
                <div key={index} className={`group border border-gray-200 col-span-${grid[2]} md:col-span-${grid[1]} lg:col-span-${grid[0]} p-5 text-center shadow-lg hover:shadow-none rounded-xl duration-500 relative`} >
                    
                    <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} height={192} />

                    <div className="text-center">
                        <h3 className="text-lg font-semibold text-gray-800 group-hover:text-gray-600">
                            <Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} />
                        </h3>

                        <div className="mt-2 flex justify-center items-center space-x-3">
                            <span className="text-[var(--orange)] font-bold text-md lg:text-xl"><Skeleton baseColor="#f2f2f7" highlightColor="#fff" borderRadius={12} width={100} /></span>
                        </div>
                        
                        <span className="mt-4 px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-600 hover:shadow-md duration-300 block w-fit m-auto">
                            {t('more')}
                        </span>
                    </div>
                </div>
            ))
            
        :
        (
            typeof data === "object" && data !== null ? (
                data.data.data.map(item => {
                    return  (
                        <div
                            key={item.id}
                            className={`group border border-gray-200 col-span-${grid[2]} md:col-span-${grid[1]} lg:col-span-${grid[0]} p-3 lg:p-5 text-center shadow-lg hover:shadow-none rounded-xl duration-500 relative`}
                        >
                            { 
                                item.discounted ?
                                    <div className="absolute top-3 left-3 bg-red-500 text-white text-xs uppercase font-bold px-3 py-1 rounded-full z-20">
                                        Sale
                                    </div>
                                :
                                ''
                            }
                            {
                                item.live_stock > 0 ? 
                                <div
                                    onClick={() => addToCart(item.id)}
                                    className={`absolute cursor-pointer top-3 right-3 ${
                                        toCart?.products?.[item.id] ? "bg-[var(--orange)]" : "bg-[#e5e7eb]"
                                    } w-[45px] h-[45px] flex items-center justify-center rounded-full z-20 text-[20px]`}
                                >
                                    <RiShoppingCartLine />
                                </div>
                                :
                                <span className="absolute top-3 right-3 z-20 text-[10px] font-bold text-red-600">{t('out_of_stock')}</span>
                            }
                            
            
                            <img
                                src={`${process.env.REACT_APP_API_URL}/storage/uploads/products/thumbs/large_${item.img}`}
                                alt={item.translations[0]?.name || "No title"}
                                className="w-full h-[150px] lg:h-48 object-cover rounded-md mb-4 transition-transform duration-500 group-hover:scale-105"
                            />
            
                            <div className="text-center">
                                <h3 className="text-xs lg:text-lg font-semibold text-gray-800 group-hover:text-gray-600">
                                    { item.translations[0]?.name }
                                </h3>
            
                                <div className="mt-2 flex justify-center items-center space-x-3">
                                    
                                    { 
                                        item.discounted ?
                                            <>
                                                <span className="text-[var(--orange)] font-bold text-md lg:text-xl">{ item.discounted } ₾</span>
                                                <span className="text-gray-400 text-sm line-through">{ item.price } ₾</span>
                                            </>
                                        :
                                        <span className="text-[var(--orange)] font-bold text-md lg:text-xl">{ item.price } ₾</span>
                                    }
                                </div>
                                
                                <Link to={`/${locale}/product/${item.slug}`} className="mt-4 px-2 lg:px-6 py-2 bg-gray-800 text-white rounded-lg hover:bg-gray-600 hover:shadow-md duration-300 block w-fit m-auto">
                                    {t('more')}
                                </Link>
                            </div>
                        </div>
                    )
                })
            ) : null
        )
        
    )
    
        
    
        
}